(function () {
  const COUNTRY_PREFIX_ATTRIBUTE = 'data-phone-prefix';

  function updateSelectPlaceholderState(select) {
    select.classList.toggle('vaillant-mto__select--placeholder', !select.value);
  }

  function syncPrefixFromCountry(countrySelect, prefixSelect) {
    const prefix = countrySelect.selectedOptions[0]?.getAttribute(COUNTRY_PREFIX_ATTRIBUTE);
    if (!prefix) return;

    const matchingOption = [...prefixSelect.options].find((option) => option.value === prefix);
    if (matchingOption) {
      prefixSelect.value = prefix;
      updateSelectPlaceholderState(prefixSelect);
    }
  }

  function initDateField(input) {
    input.addEventListener('focus', () => {
      input.type = 'date';
      if (typeof input.showPicker === 'function') {
        try {
          input.showPicker();
        } catch (error) {
          // Browsers can reject showPicker outside a user gesture; the native field still works.
        }
      }
    });

    input.addEventListener('blur', () => {
      if (!input.value) input.type = 'text';
    });
  }

  function initForm(form) {
    if (form.dataset.mtoInit === 'true') return;
    form.dataset.mtoInit = 'true';

    form.querySelectorAll('select').forEach((select) => {
      updateSelectPlaceholderState(select);
      select.addEventListener('change', () => updateSelectPlaceholderState(select));
    });

    const countrySelect = form.querySelector('[data-mto-country]');
    const prefixSelect = form.querySelector('[data-mto-prefix]');
    if (countrySelect && prefixSelect) {
      countrySelect.addEventListener('change', () => syncPrefixFromCountry(countrySelect, prefixSelect));
    }

    form.querySelectorAll('[data-mto-date]').forEach(initDateField);
  }

  function initAll() {
    document.querySelectorAll('.vaillant-mto__form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
